import Dialog from '@mui/material/Dialog';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, {
    useState,
} from 'react';

import PhotoType from '../../../types/PhotoType';

import POLMasonry from '../POLMasonry';

import PhotosScroller from './PhotosScroller';

import styles from './Gallery.scss';

const Gallery = ({
    photos,
}) => {
    const [
        isPhotosDialogOpen,
        setIsPhotosDialogOpen,
    ] = useState(false);
    const [
        currentPhotoIndex,
        setCurrentPhotoIndex,
    ] = useState(0);

    const handleOnImgClick = (index) => {
        setCurrentPhotoIndex(index);
        setIsPhotosDialogOpen(true);
    };

    if (isEmpty(photos)) return null;

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h3 className={styles.headline}>Gallery</h3>
            </div>
            <POLMasonry
                photos={photos}
                onImgClick={handleOnImgClick}
            />
            <Dialog
                open={isPhotosDialogOpen}
                onClose={() => setIsPhotosDialogOpen(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <PhotosScroller photos={photos} currentPhotoIndex={currentPhotoIndex} />
            </Dialog>
        </div>
    );
};

Gallery.propTypes = {
    photos: PropTypes.arrayOf(PhotoType).isRequired,
};

export default Gallery;
